import React from "react";
import { createSvgIconComponent } from "../utils";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var IconVisa = createSvgIconComponent({
  viewBox: "0 0 32 10",
  fill: "url(#icon-visa-gradient)",
  path: "M23.26.4A6.79,6.79,0,0,0,20.94,0c-2.56,0-4.37,1.29-4.38,3.14,0,1.36,1.29,2.13,2.27,2.58s1.34.76,1.34,1.18c0,.64-.8.93-1.55.93a5.58,5.58,0,0,1-2.44-.5l-.32-.15L15.5,9.31a8.72,8.72,0,0,0,2.9.5c2.72,0,4.5-1.28,4.52-3.25,0-1.09-.68-1.91-2.16-2.59-.9-.44-1.46-.73-1.46-1.18S19.78,2,20.78,2a4.83,4.83,0,0,1,1.94.37l.24.11L23.32.39ZM29.9.17h-2A1.3,1.3,0,0,0,26.54,1L22.7,9.67h2.72L26,8.25h3.32c.08.33.32,1.42.32,1.42H32Zm-17-.08h2.59L13.85,9.6H11.26L12.88.09ZM6.29,5.33l.27,1.32L9.1.17h2.74L7.76,9.66H5l-2.24-8a.5.5,0,0,0-.24-.32A10.45,10.45,0,0,0,0,.37l0-.2H4.21A1.09,1.09,0,0,1,5.39,1l.9,4.37Zm20.42,1,1-2.66.34-.9.18.82.6,2.74Z",
  children: ___EmotionJSX("defs", null, ___EmotionJSX("linearGradient", {
    id: "icon-visa-stop-colors"
  }, ___EmotionJSX("stop", {
    offset: "0",
    stopColor: "#222357"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#254aa5"
  })), ___EmotionJSX("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: "4.9049791",
    x2: "32",
    y1: "4.9049791",
    x1: "0",
    id: "icon-visa-gradient",
    xlinkHref: "#icon-visa-stop-colors"
  }))
});